export const Scorebar = ({product, scoreType, height, width}) => {
  const scoreData = product.scoreProperties[scoreType];

  return (
    <div className="score_bar_container" style={{height, width}}>
      <div
        className="score_bar_gradient"
        style={{backgroundColor: '#' + scoreData.hexColor}}
      ></div>
      <div
        className="score_bar_gradient_grey"
        style={{
          width: `${100 - scoreData.score + 0.5}%`,
          left: `${scoreData.score}%`
        }}
      ></div>
      <div className="score_bar_gradient_text_container">
        <span>{scoreData.score.toFixed(1)}%</span>
      </div>
    </div>
  );
}
